import React from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import '../auth/InlineProfileCompletionModal.css'

export default function RequireAvailabilityModal({ show, onClose, leagueId }) {
  const navigate = useNavigate()

  const handleAddAvailability = () => {
    onClose() // Close modal first
    navigate(`/leagues/${leagueId}/schedule-month`)
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      e.preventDefault()
      onClose()
    }
  }

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  if (!show) return null

  return (
    <div
      className="fl-sheet-overlay"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      aria-labelledby="availability-required-title"
      onKeyDown={handleKeyDown}
      onClick={handleOverlayClick}
    >
      <div
        className="fl-sheet"
        role="document"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="fl-sheet-header">
          <h2 id="availability-required-title" className="fl-sheet-title">
            🗓️ Availability Required
          </h2>
          <p className="fl-sheet-subtitle">
            Before proposing a match, you need to add your availability for this
            league.
          </p>
        </div>

        <div className="fl-sheet-body">
          <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.6' }}>
            This helps ensure you and your opponents can find good times to
            play.
          </p>
        </div>

        <div className="fl-actions">
          <button
            type="button"
            className="fl-btn fl-btn-secondary"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="fl-btn fl-btn-primary"
            onClick={handleAddAvailability}
          >
            Add Availability
          </button>
        </div>
      </div>
    </div>
  )
}

RequireAvailabilityModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  leagueId: PropTypes.number.isRequired,
}
